import { createContext } from "react";
const NetworkContext = createContext();
export default NetworkContext;